module.exports = __webpack_public_path__ + "site/img/61.81acbd13.jpg";